import React from 'react';

import { useQueryClient } from 'react-query';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import useUserHook from 'hooks/useUserHook';

import { useMutationCreateEditStory } from 'api/mutations/createEditStory.mutation';

import AddStoryForm from 'components/Dashboards/Project/Components/DataStories/AddStoryForm/AddStoryForm';
import { Button } from 'components/DesignSystem/Button';
import { Modal } from 'components/DesignSystem/Modal';

export const AddStoryModal = ({ open, onClose, project, contract, dataStories, editStory }) => {
    const { ability } = useUserHook();
    const queryClient = useQueryClient();
    const { handleSnackBar } = useCustomSnackBar();
    const { mutate: mutateCreateEditStory, isLoading: isLoadingCreateEditStory } = useMutationCreateEditStory();

    const handleSaveStory = (obj) => {
        mutateCreateEditStory(obj, {
            onSuccess: () => {
                queryClient.invalidateQueries('dataStories').then(() => {
                    handleSnackBar('Feed successfully saved', 'success');
                    onClose();
                    Promise.all([
                        queryClient.invalidateQueries('expandStory'),
                        queryClient.invalidateQueries('getStoryImage'),
                    ]);
                });
            },
            onError: (error) => {
                DEFAULT_ERROR({ error, handleError: handleSnackBar });
            },
        });
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={`${editStory ? 'Edit' : 'Add'} Data Story`}
            actions={
                <>
                    <Button size={'medium'} variant={'secondary'} onClick={onClose}>
                        Cancel
                    </Button>

                    <Button
                        type={'submit'}
                        size={'medium'}
                        variant={'primary'}
                        isLoading={isLoadingCreateEditStory}
                        disabled={isLoadingCreateEditStory}
                        form={'add-data-story-form'}
                    >
                        Save
                    </Button>
                </>
            }
        >
            <AddStoryForm
                project={project}
                contract={contract}
                saveStory={handleSaveStory}
                tags={dataStories?.pages[0]?.tags}
                editData={editStory}
                isAdmin={ability.can('all', 'Admin')}
            />
        </Modal>
    );
};
